import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import SocialPostsAPI from '../../api/socialPosts';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isPublishing: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getSocialPosts(_state) {
    return _state.records;
  },
  getSocialPost: _state => id => {
    return _state.records.find(record => record.id === Number(id));
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_SOCIAL_POST_UI_FLAG, { isFetching: true });
    try {
      const response = await SocialPostsAPI.get();
      commit(types.SET_SOCIAL_POSTS, response.data);
    } finally {
      commit(types.SET_SOCIAL_POST_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, formData) => {
    commit(types.SET_SOCIAL_POST_UI_FLAG, { isCreating: true });
    try {
      const response = await SocialPostsAPI.create(formData);
      commit(types.ADD_SOCIAL_POST, response.data);
      return response.data;
    } finally {
      commit(types.SET_SOCIAL_POST_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, formData }) => {
    commit(types.SET_SOCIAL_POST_UI_FLAG, { isUpdating: true });
    try {
      const response = await SocialPostsAPI.update(id, formData);
      commit(types.EDIT_SOCIAL_POST, response.data);
      return response.data;
    } finally {
      commit(types.SET_SOCIAL_POST_UI_FLAG, { isUpdating: false });
    }
  },
  // Devuelve el resultado por red para que el historial pueda decir que quedo
  // publicado y hay que borrar a mano.
  delete: async ({ commit }, { id, removeFromNetworks = false }) => {
    commit(types.SET_SOCIAL_POST_UI_FLAG, { isDeleting: true });
    try {
      const response = await SocialPostsAPI.delete(id, { removeFromNetworks });
      commit(types.DELETE_SOCIAL_POST, id);
      return response.data?.results ?? [];
    } finally {
      commit(types.SET_SOCIAL_POST_UI_FLAG, { isDeleting: false });
    }
  },
  publish: async ({ commit, dispatch }, id) => {
    commit(types.SET_SOCIAL_POST_UI_FLAG, { isPublishing: true });
    try {
      await SocialPostsAPI.publish(id);
      // Publishing runs in the background, including Instagram container polling.
      await dispatch('get');
    } finally {
      commit(types.SET_SOCIAL_POST_UI_FLAG, { isPublishing: false });
    }
  },
};

export const mutations = {
  [types.SET_SOCIAL_POST_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },

  [types.ADD_SOCIAL_POST]: MutationHelpers.create,
  [types.SET_SOCIAL_POSTS]: MutationHelpers.set,
  [types.EDIT_SOCIAL_POST]: MutationHelpers.update,
  [types.DELETE_SOCIAL_POST]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
